import React from 'react'
import { useSelector } from 'react-redux'
import UserLogoutButton from '../form/logout/UserLogoutButton'

const UserInfoOptions = () => {

    const user = useSelector(state => state.user.user)

  return (
    <div>
        {/* {user.id} {user.name} */}
        <UserLogoutButton />
    </div>
  )
}

export default UserInfoOptions